import { CurrentSupplierUserInterface } from 'shared/interfaces/current-supplier-user.interface';
import { CurrentUserInterface } from './current-user.interface';

export interface CurrentShijiUserInterface extends CurrentUserInterface {
    shijiPermissions: ShijiPermissions[];
}

export interface ShijiPermissions {
    id: string;
    isAuthorized: boolean;
    shijiAccessZone: string;
}

export function isShijiUser(user: CurrentSupplierUserInterface | CurrentShijiUserInterface): user is CurrentShijiUserInterface {
    return Array.isArray((user as CurrentShijiUserInterface).shijiPermissions);
}
